export default __webpack_public_path__ + "static/media/multiplier-best.22dfe3d7.wav";